var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from 'path-shared/models/filter-data';
var NotificacionsDenunciaFilter = /** @class */ (function (_super) {
    __extends(NotificacionsDenunciaFilter, _super);
    function NotificacionsDenunciaFilter(sortField, sortDir) {
        var _this = _super.call(this, sortField, sortDir) || this;
        _this.element = null;
        _this.judicial = null;
        _this.dataIni = null;
        _this.dataFi = null;
        _this.labels['element'] = _this.i18n('Expedient');
        _this.labels['judicial'] = _this.i18n('Judicial');
        _this.labels['dataIni'] = _this.i18n['DataIni'];
        _this.labels['dataFi'] = _this.i18n['DataFi'];
        return _this;
    }
    return NotificacionsDenunciaFilter;
}(FilterData));
export { NotificacionsDenunciaFilter };
